export const sanitizeRedirectUrl = url => {
  if (typeof url !== "string") return null;

  // Strip leading/trailing whitespace
  const trimmed = url.trim();

  // Must start with exactly one "/" (not "//" which is protocol-relative)
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return null;

  // Block dangerous protocols that browsers may resolve (e.g. "/ javascript:...")
  try {
    const parsed = new URL(trimmed, window.location.origin);
    if (parsed.origin !== window.location.origin) return null;
  } catch {
    return null;
  }

  return trimmed;
};

// Returns the first two path segments (e.g. "/profile/accounts") of a
// location pathname, falling back to /profile/accounts when the result is not
// a safe same-origin path (e.g. "//evil.com").
export const getSafeTopLevel = pathname => {
  const topLevel =
    typeof pathname === "string"
      ? pathname
          .split("/")
          .filter((_, index) => index <= 2)
          .join("/")
      : null;
  return sanitizeRedirectUrl(topLevel) || "/profile/accounts";
};
